<template>
  <div class="tc-marketing" :class="{ 'tc-marketing-dark': isDark }">
    <a class="tm-skip" href="#main-content">Skip to content</a>
    <header class="tm-header">
      <router-link class="tm-brand" to="/" aria-label="TradingCandle home"
        ><span class="tm-brand-icon"
          ><img src="/logo.png" width="23" height="23" alt="" aria-hidden="true"
        /></span>
        <span>TradingCandle</span></router-link
      >
      <nav
        class="tm-nav"
        :class="{ 'is-open': mobileOpen }"
        aria-label="Main navigation"
      >
        <a href="/#features" @click="mobileOpen = false">Features</a
        ><router-link to="/pricing" @click.native="mobileOpen = false"
          >Pricing</router-link
        ><router-link to="/download" @click.native="mobileOpen = false"
          >Download</router-link
        ><router-link to="/help" @click.native="mobileOpen = false"
          >Resources</router-link
        >
      </nav>
      <div class="tm-header-actions">
        <button
          class="tm-icon-button"
          @click="$store.dispatch('toggleTheme')"
          :aria-label="
            isDark ? 'Switch to light theme' : 'Switch to dark theme'
          "
        >
          <MarketingIcon :name="isDark ? 'sun' : 'moon'" :size="18" />
        </button>
        <router-link
          v-if="$clerk.isAuthenticated"
          to="/dashboard"
          class="tm-signin"
          >My account</router-link
        ><button v-else class="tm-signin" @click="$clerk.openSignIn()">
          Sign in
        </button>
        <button class="tm-button tm-button-small tm-header-cta" @click="start">
          {{ $clerk.isAuthenticated ? "Open charts" : "Get started"
          }}<MarketingIcon name="arrow" :size="15" />
        </button>
        <button
          class="tm-icon-button tm-mobile-toggle"
          @click="mobileOpen = !mobileOpen"
          :aria-expanded="mobileOpen"
          aria-label="Toggle navigation"
        >
          <MarketingIcon :name="mobileOpen ? 'close' : 'menu'" />
        </button>
      </div>
    </header>
    <main id="main-content"><slot /></main>
    <footer class="tm-footer">
      <div class="tm-footer-top">
        <div>
          <router-link to="/" class="tm-footer-brand"
            >TradingCandle</router-link
          >
          <p>
            A clearer view of the market.<br />A workspace that works your way.
          </p>
        </div>
        <div>
          <strong>Explore</strong><a href="/#features">Features</a
          ><router-link to="/pricing">Pricing</router-link
          ><router-link to="/download">Download</router-link>
        </div>
        <div>
          <strong>Get to know us</strong
          ><router-link to="/help">Help &amp; guides</router-link
          ><router-link to="/dashboard">My account</router-link>
        </div>
        <div>
          <strong>Legal</strong
          ><router-link to="/terms">Terms of service</router-link
          ><router-link to="/privacy">Privacy policy</router-link>
        </div>
      </div>
      <div class="tm-footer-bottom">
        <span>© {{ year }} TradingCandle.</span>
        <p>
          Made for a clearer market perspective. Data availability varies by
          provider.
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
import MarketingIcon from "./MarketingIcon.vue";
import "./marketing.css";
import "./product-design.css";
export default {
  components: { MarketingIcon },
  data: () => ({ mobileOpen: false, year: new Date().getFullYear() }),
  computed: {
    isDark() {
      return this.$store.getters.isDarkTheme;
    },
  },
  methods: {
    start() {
      if (this.$clerk.isAuthenticated) this.$router.push("/chart");
      else this.$clerk.openSignUp();
    },
  },
};
</script>
